import template from './my-orders-actions-menu.html';
var MyOrdersActionsMenuController = /** @class */ (function () {
    /*@ngInject*/
    function MyOrdersActionsMenuController(Auth, $state, $scope, $location, googleAnalytic) {
        this.limit = 10;
        this.currentState = null;
        this.orderOptions = [
            {
                title: 'Review Order History',
                state: 'orderHistory'
            },
            {
                title: 'Reorder Products',
                state: 'reorderProducts'
            },
            {
                title: 'Unprocessed Orders',
                state: 'failedOrders'
            },
            {
                title: 'Back Orders',
                state: 'backOrders',
                eventName: 'Back Order Page'
            }
        ];
        this.orderListVisible = false;
        this.isOrderPlaceholder = true;
        this.orderPlaceholder = "";
        this.orderShow = function () {
            this.orderListVisible = true;
        };
        this.ga = googleAnalytic;
        for (var orders in this.orderOptions) {
            if (this.orderOptions[orders]['state'] == $state.current.name)
                this.currentState = this.orderOptions[orders]['title'];
        }
        this.orderPlaceholder = this.currentState;
        this.selectOrderPage = function (item) {
            this.orderListVisible = false;
            $state.go(item.state);
        };
    }
    MyOrdersActionsMenuController.prototype.trackEvent = function (eventName) {
        if (!eventName)
            return;
        this.ga.sendEvent('Customer', eventName, 'click', 1);
    };
    return MyOrdersActionsMenuController;
}());
export { MyOrdersActionsMenuController };
export var MyOrdersActionsMenuComponent = {
    template: template,
    controller: MyOrdersActionsMenuController
};
//# sourceMappingURL=my-orders-actions-menu.component.js.map